"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilteredRoomDiscounts = void 0;
const _ = require("lodash");
const calculateStackedDiscount_1 = require("../calculateStackedDiscount");
const dayjs = require("dayjs");
const getFilteredRoomDiscounts = (date_of_confirmation, check_in_date, applicable_discount) => {
    let days_until_checkin = 0;
    // to do extrapolate into its own function
    if (date_of_confirmation) {
        days_until_checkin = dayjs(check_in_date).diff(dayjs(date_of_confirmation), "days");
    }
    else {
        days_until_checkin = dayjs(check_in_date).diff(dayjs(), "days");
    }
    const discount = _.cloneDeep(applicable_discount);
    if (!discount)
        return null;
    if (discount.early_bird) {
        // check discount.early_bird is an array.  if its not make it an array
        if (!Array.isArray(discount.early_bird)) {
            discount.early_bird = [discount.early_bird];
        }
        discount.early_bird = discount.early_bird.filter((discount) => {
            if (!discount || !discount.min_days_in_advance)
                return false;
            return discount.min_days_in_advance <= days_until_checkin;
        });
    }
    // calculate the best discount
    const early_bird_discount_percentage = discount.early_bird && discount.early_bird.length > 0
        ? discount.early_bird.sort((a, b) => {
            const minDaysA = a.min_days_in_advance ?? -Infinity;
            const minDaysB = b.min_days_in_advance ?? -Infinity;
            if (minDaysA !== minDaysB) {
                return minDaysB - minDaysA; // Sort by min_days_in_advance descending
            }
            else {
                return a.discount_percentage - b.discount_percentage; // Sort by discount_percentage ascending
            }
        })[0].discount_percentage
        : 0;
    const long_stay_discount_percentage = discount.long_stay
        ? discount?.long_stay?.discount_percentage
        : 0;
    discount.best = {
        discount: discount.stackable
            ? (0, calculateStackedDiscount_1.calculateStackedDiscount)(discount.early_bird && discount.early_bird.length > 0
                ? early_bird_discount_percentage
                : 0, discount.long_stay ? long_stay_discount_percentage : 0)
            : Math.max(discount.early_bird && discount.early_bird.length > 0
                ? early_bird_discount_percentage
                : 0, discount.long_stay ? long_stay_discount_percentage : 0),
        type: discount.stackable &&
            discount.early_bird &&
            discount.early_bird.length > 0 &&
            discount.long_stay
            ? "early_bird_and_long_stay"
            : early_bird_discount_percentage > long_stay_discount_percentage
                ? "early_bird"
                : "long_stay",
    };
    return discount;
};
exports.getFilteredRoomDiscounts = getFilteredRoomDiscounts;
